// extracted by mini-css-extract-plugin
module.exports = {"tabs":"ChessModal_tabs__2hyd7"};